import { z } from 'zod';

const ratingSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
  value: z.number(),
  color: z.string(),
});

export const riskAssessmentResultConfigSchema = z.object({
  likelihood: z.object({
    ratings: z.array(ratingSchema),
  }),
  impact: z.object({
    ratings: z.array(ratingSchema),
    categories: z.array(z.object({ name: z.string(), color: z.string() })),
    aggregation: z.enum(['average', 'maximum']).optional(),
  }),
  matrix: z.array(
    z.object({
      title: z.string(),
      value: z.number(),
      color: z.string(),
      likelihood: z.number(),
      impact: z.number(),
    })
  ),
});

export type RiskAssessmentResultConfig = z.infer<
  typeof riskAssessmentResultConfigSchema
>;
